import Vue from "vue";
import Vuetify from "vuetify/lib";
import es from "vuetify/es5/locale/es";
import en from "vuetify/es5/locale/en";

Vue.use(Vuetify);

const opts = {
  theme: {
    themes: {
      light: {
        primary: "#024997",
      },
    },
  },
  lang: {
    locales: { en, es },
    current: "es",
  },
};

export default new Vuetify(opts);
